const lang = {
    "Kep": "QES",
    "KepNotLinked": "nitelikli e-imzanız henüz bir hesaba bağlı değil. Her zamanki gibi giriş yapın, biz bağlayalım.",
    "KepNewAccount": "Hesabınız yok mu? Kaydolun",
    "KepLinked": "Nitelikli e-imza hesaba bağlandı",
    "KepLinkFailed": "Nitelikli e-imza bağlanamadı. Onunla tekrar giriş yapın, biz bağlayalım",
    "KepFile": "Anahtar dosyası",
    "ErrorKepLogin": "Nitelikli e-imza ile giriş yapılamadı",
    "EnterWidth": "İle giriş:",
    "Registration": "Kayıt olmak",
    "enter": "İçeri gel",
    "EntrWidthEmailOrPhone": "E-posta veya telefonla giriş yapın",
    "login": "Yetkilendirme",
    "NoAkkGoReg": "Kayıt olmak",
    "Password": "Parola",
    "Name": "İsim",
    "LastName": "Soyadı",
    "Phone": "Kayıt olmak için telefon numaranızı giriniz",
    "Email": "Posta",
    "RepeatPassword": "Şifreyi tekrar girin",
    "Сancel": "İptal etmek",
    "Save": "Kaydetmek",
    "Language": "Dilim",
    "ConfirmThisMail": "E-posta teyit edilmiştir",
    "Saved": "kaydedildi",
    "Error": "Hata",
    "FillInAllTheFields": "Tüm alanları doldurun",
    "Next": "Daha ileri",
    "MinPassLength": "Minimum şifre uzunluğu 4 karakter",
    "ForgotYourPassword": "Parolanızı mı unuttunuz",
    "RestorePassword": "Lütfen yeni bir şifre belirleyin.",
    "UserMustBeRegistered": "Kullanıcı kayıtlı olmalıdır",
    "Confirm": "Onaylamak",
    "WrongFormat": "Yanlış format",
    "WrongPassword": "yanlış parola",
    "WrongLoginOrPassword": "yanlış giriş veya şifre",
    "PhoneAlreadyRegistered": "Telefon zaten kayıtlı",
    "EmailAlreadyRegistered": "Posta zaten kayıtlı",
    "FillInTheFieldsCorrectly": "Alanları doğru doldurun",
    "ThisAccountDoesNotExist": "Bu hesap mevcut değil",
    "LinkIsNotValid": "Bağlantı geçerli değil",
    "AMessageHasBeenSentToTheSpecifiedLogin": "Belirtilen kullanıcı adına bir mesaj gönderildi",
    "IncorrectCaptcha": "yanlış CAPTCHA",
    "CaptchaIsNotValid": "Captcha artık geçerli değil",
    "EnterCaptcha": "Captcha'yı girin",
    "EnterSMS": "SMS'den kodu girin",
    "SMSCodeIsNoLongerValid": "SMS kodu artık geçerli değil",
    "SMSCodeIsIncorrect": "SMS kodu yanlış",
    "MailNotVerifiedLinkTimedOut": "Posta onaylanmadı, bağlantının süresi doldu",
    "DemoLogin": "Demo girişi",
    "AreYouSureYouWantToEnterTheDemoForEvaluation": "Denemek için <b> demoya </b> girmek istediğinizden emin misiniz?",
    "FillInAdditionalInformation": "Ek bilgileri doldurun",
    "ToCompleteRegistration": "Kaydı tamamlamak için",
    "LinkThirdPartyServices": "Üçüncü taraf hizmetlerini bağla",
    "Complete": "Tamamlamak",
    "AccountAlreadyLinked": "Hesap zaten bağlı",
    "AccountNotRegistered": "Hesap kayıtlı değil",
    "NotMyNumber": "benim numaram değil",
    "Back": "Geri",
    "numberOfAttemptsToCheckAuth": "Oturum açma denemesi sayısı:",
    "InvalidPassNumberOfAttemptsToCheckAuth": "Yanlış şifre, giriş denemesi sayısı:",
    "TryAgainAfterMinute": "Lütfen 2 dakika sonra tekrar deneyin",
    "Help": "Destek olmak",
    "y": "Evet",
    "n": "Değil",
    "doYouConfirmEmail": "E-postanızı değiştirmek istediğinizden emin misiniz?",
    "success": "başarıyla",
    "goToAutorize": "Yetkilendirmeye git",
    "UserEmailAlreadyExists": "Bu emaile sahip kullanıcı zaten var",
    "UserPhoneAlreadyExists": "Bu telefon numarasına sahip kullanıcı zaten var",
    "TermOfUse": "Kullanım Şartları",
    "PrivacyPolicy": "Gizlilik Politikası",
    "accountNotRegistered": "hesap kayıtlı değil",
    "wantToReg": "Kayıt olmak ister misiniz?",
    "weSuccessChangeYouEmail": "E-posta adresinizi başarıyla değiştirdik",
    "youCanCloseThisWindow": "Bu pencereyi kapatabilirsiniz",
    "countryConfirm": "Ülke Onayı",
    "EmailAlreadyTied": "Posta zaten başka bir hesaba bağlı",
    "areYourCountry": "bu senin ülken mi?",
    "EmergencyEntrance": "Eski Yetkilendirme",
    "enterCorrectNumber": "Numarayı uluslararası formatta girin",
    "thisPhoneRegister": "Bu telefon numarası zaten sistemde kayıtlı",
    "wantUsePhoneForAuth": "Bu telefon numarasını kullanarak giriş yapmak ister misiniz?",
    "ok": "tamam",
    "regAgree": "Bir hesap kaydederek kabul ediyorum",
    "wantBind": "Oturum açmak ve hizmeti bağlamak istiyorum",
    "bind": "bağlamak",
    "yoursMailBinded": "E-postanız mevcut bir hesapta",
    "wantUsePhoneAndBind": "zaten sistemde kayıtlı",
    "notGetDataFromApple": "Apple'dan veri alınamadı",
    "ErrorAppleLogin": "Apple üzerinden yetkilendirme hatası",
    "ErrorGoogleLogin": "Google üzerinden yetkilendirme hatası",
    "ErrorTelegramLogin": "Telegram üzerinden giriş yaparken hata oluştu",
    "ErrorFacebookLogin": "Facebook üzerinden giriş yaparken hata oluştu",
    "EMailOrPhone": "Lütfen geçerli bir telefon numarası veya e-posta adresi girin.",
    "withoutName": "İsim yok",
    "goToCabinet": "Ofise",
    "Logout": "Oturum sonu",
    "creationDate": "Oluşturulma tarihi",
    "preparingCompany1": "Şirketinizi kuruyoruz, lütfen bize bir dakika verin...",
    "preparingCompany2": "Mal ve hizmetlerin yönetimi için bir arayüz hazırlıyoruz...",
    "preparingCompany3": "Kolay finansal muhasebe üzerinde çalışıyoruz...",
    "preparingCompany4": "Son ayarlamaları yapıyoruz, neredeyse hazırız...",
    "companyBlocked": "Bu şirket aktif değil",
    "youBlockedInComp": "Kullanıcı aktif değil, giriş mümkün değil",
    "loginTitle": "Bir işletmenin ihtiyaç duyduğu her şey tek bir yerde",
    "loginDescr": "Mağazalar, kafeler, teslimat hizmetleri, restoranlar, depolar, üretim veya hizmetler için otomasyon",
    "NoAkkGoRegText": "Hesabınız yok mu?",
    "LoginPlaceholder": "Lütfen gerekli bilgileri sağlayın",
    "loginText": "Zaten bir hesabınız var mı?",
    "and": "Ve",
    "AcceptTheTerms": "Lütfen gizlilik politikasını ve kullanım koşullarını kabul edin",
    "CountryPhoneFormat": "Eğer bu ülke sizin ülkeniz değilse, lütfen telefon numaranızı doğru uluslararası formatta girdiğinizden emin olun.",
    "SaveNewPassword": "Yeni şifreyi kaydet"
}

export default function() {
    return lang;
}